import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import { ColorPicker } from 'primereact/colorpicker';
import { Tag } from 'primereact/tag';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import StatusService from '../../app/service/StatusAtividadeService'

class StatusAtividades extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: null,
      statusLista: [],
      codigo: '',
      nome: '',
      cor: 'ffffff',
      modalStaus: false,
      modalStatusAlterar: false,
      openSpinner: false,
    }

    this.statusService = new StatusService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroStatus = this.renderFooterCadastroStatus.bind(this);
    this.renderFooterAlterarStatus = this.renderFooterAlterarStatus.bind(this);
  }

  listarStatus = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.statusService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusLista: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({status: null});
    this.setState({nome: ''});
    this.setState({cor: 'ffffff'});
  }

  colorFase(data) {
    return(
      <React.Fragment>
        <Tag className="p-mr-2" style={{backgroundColor: `${data.cor}`, width: '45px', height: '15px'}}></Tag>
      </React.Fragment>
    )
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarStatus(rowData)}
                tooltip="Editar Status" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Status" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(status) {
    this.setState({codigo: status.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Status de Atividade?',
        header: 'Exclusão de Status de Atividade',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirStatus() {
    this.setState({openSpinner: true});
    this.statusService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Status de Atividade', detail:'Status deAtividade excluído com sucesso', life: 4000});
        this.listarStatus();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirStatus();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroStatus(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarStatus}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarStatus(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarStatus}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarStatus(status){
    this.setState({openSpinner: true});
    this.statusService.consultar(status.codigo)
      .then(response => {
        this.setState({status: response.data});
        this.setState({nome: response.data.status});
        this.setState({codigo: response.data.codigo});
        this.setState({cor: response.data.cor2});
        this.abrirModaAlterar('modalStatusAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarStatus = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Status de Atividade', detail:'O nome do Status de Atividade é obrigatório', life: 4000});
      return;
    }
    const status = {
      status: this.state.nome,
      cor: this.state.cor,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.statusService.cadastrar(status)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Status de Atividade', detail:'Status de Atividade cadastrado com sucesso', life: 4000});
        this.fecharModal('modalStatus');
        this.listarStatus();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarStatus = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Status de Atividade', detail:'O nome do Status de Atividade é obrigatório', life: 4000});
      return;
    }

    const status = {
      codigo: this.state.codigo,
      status: this.state.nome,
      cor: this.state.cor,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.statusService.alterar(status)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Status de Atividade', detail:'Status de Atividade alterado com sucesso', life: 4000});
        this.fecharModal('modalFaseAlterar');
        this.listarStatus();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarStatus();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Status de Atividade */}
          <Dialog header="Cadastro de Status de Atividade"
                    visible={this.state.modalStatus} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroStatus('modalStatus')} 
                    onHide={() => this.fecharModal('modalStatus')}>
                
                <div className="row">
                  <div className="col-sm-10">
                    <div className="form-group">
                        <label htmlFor="nomeStatus">Nome</label>
                        <InputText id="nomeStatus" 
                                   type="text" 
                                   value={this.state.nome}
                                   style={{width: '100%', height: '32px'}} 
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <label htmlFor="cor">Cor</label>
                    <div style={{paddingTop: '5px'}}>
                    <ColorPicker inputId="cor" 
                                  format="hex" value={this.state.cor} 
                                  onChange={e => this.setState({cor: e.target.value})}/>
                    </div>
                  </div>
                </div>
              </div>
          </Dialog>
          {/**Alterar Status de Atividade */}
          <Dialog header="Alterar Status de Atividade"
                    visible={this.state.modalStatusAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarStatus('modalStatusAlterar')} 
                    onHide={() => this.fecharModal('modalStatusAlterar')}>
                
                <div className="row">
                  <div className="col-sm-10">
                    <div className="form-group">
                      <label htmlFor="nomeStatusAlterar">Nome</label>
                      <InputText id="nomeStatusAlterar" 
                                 type="text" 
                                 value={this.state.nome}
                                 style={{width: '100%', height: '32px'}} 
                                 onChange={e => this.setState({nome: e.target.value})}
                                 className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="form-group">
                      <label htmlFor="corStatusAlterar">Cor</label>
                      <div style={{paddingTop: '5px'}}>
                      <ColorPicker inputId="corHexStatusAlterar" 
                                   format="hex" value={this.state.cor} 
                                   onChange={e => this.setState({cor: e.target.value})}/>
                      </div>
                    </div>
                  </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-map"></i>
                        <span> Status de Atividade</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalStatus')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.statusLista}  paginator responsiveLayout="scroll"
                               paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                               currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                               emptyMessage="Nenhum Status de Atividade encontrado" rows={10}>
                      <Column field="status" header="Nome"></Column>
                      <Column body={this.colorFase} exportable={false} style={{ minWidth: '8rem' }} header="Cor"/>
                      <Column field="altera" header="Pode excluir ?"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

StatusAtividades.contextType = AuthContext;
export default withRouter (StatusAtividades)